var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "analitics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.651516142
  }, /*#__PURE__*/React.createElement("g", {
    id: "Analytics---add-template-at-building-2",
    transform: "translate(-39.000000, -552.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mdi-light:chart-pie-copy",
    transform: "translate(39.000000, 552.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,3 L13,3 C17.418278,3 21,6.581722 21,11 L21,12 L12,12 L12,3 Z M13,11 L20,11 C20,7.13400675 16.8659932,4 13,4 L13,11 L13,11 Z M10,14 L18,14 C18,18.418278 14.418278,22 10,22 C5.581722,22 2,18.418278 2,14 C2,9.581722 5.581722,6 10,6 L10,14 Z M9,15 L9,7.07 C5.37202735,7.60161653 2.76860482,10.8420787 3.03115354,14.4993824 C3.29370226,18.156686 6.33329323,20.9920503 10,21 C13.4802188,21.0004627 16.4323998,18.4444618 16.93,15 L9,15 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.8b7c2398d17a4092217af31f10158ea3.svg";
export { ForwardRef as ReactComponent };